import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CountedUserCarePlanItem, UserCarePlanItem} from "../../models/user-care-plan-item.model";
import {CommonUtils} from "../../utils/common";
import {VetReservation} from "../../models/vet-reservation.model";
import {UserCarePlan} from "../../models/user-care-plan.model";
import {VetReservationService} from "../../providers/vet-reservation.service";

type VetReservationExtendedCarePlanItem = UserCarePlanItem & {
  vetReservation: VetReservation;
}

@Component({
  selector: 'app-user-care-plan-services',
  templateUrl: './user-care-plan-services.component.html',
  styleUrls: ['./user-care-plan-services.component.scss'],
})
export class UserCarePlanServicesComponent implements OnInit, OnChanges {
  @Input() countedVisitCarePlanItems: CountedUserCarePlanItem[];
  @Input() userCarePlan: UserCarePlan;
  @Input() userCarePlanItems: UserCarePlanItem[];
  @Input() vetReservation: VetReservation;
  @Input() vetReservationCarePlanItems: UserCarePlanItem[];
  @Output() userCarePlanItemExecutedEventEmitter: EventEmitter<UserCarePlanItem> = new EventEmitter<UserCarePlanItem>();
  @Output() reservationRedirectEventEmitter: EventEmitter<UserCarePlanItem> = new EventEmitter<UserCarePlanItem>();
  @Input() colSize: number;
  @Input() isBusy: boolean;
  colOffset: number;


  constructor(private commonUtils: CommonUtils) { }

  ngOnInit() {

    this.sortVisitCarePlanItems();
    if (!this.colSize) {
      this.colSize = 6;
    }
    this.colOffset = (12 - this.colSize) / 2;
  }

  sortVisitCarePlanItems() {
    this.countedVisitCarePlanItems.sort((a, b) => {
      const aWellnessPlanItem = this.userCarePlan.wellnessPlan.wellnessPlanItems.find(wellnessPlanItem => wellnessPlanItem.carePlanServiceUUID === a.carePlanServiceUUID);
      const bWellnessPlanItem = this.userCarePlan.wellnessPlan.wellnessPlanItems.find(wellnessPlanItem => wellnessPlanItem.carePlanServiceUUID === b.carePlanServiceUUID);

      return aWellnessPlanItem.orderIndex - bWellnessPlanItem.orderIndex;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countedVisitCarePlanItems'] && this.countedVisitCarePlanItems) {
      this.sortVisitCarePlanItems();
    }
  }

  getServiceNumberString(carePlanServiceUUID: string, filterFieldName: string = 'carePlanServiceUUID') {
    const serviceVisits = this.userCarePlanItems.filter(userCarePlanItem => userCarePlanItem[filterFieldName] === carePlanServiceUUID);
    const numberOfVisits = serviceVisits.length;
    const numberOfAvailableVisits = serviceVisits.filter(serviceVisit => serviceVisit.realizationDate === null).length;
    if (numberOfVisits !== numberOfAvailableVisits) {
      return `dostępne: ${numberOfAvailableVisits} z ${numberOfVisits}`;
    }
    return `dostępne: ${numberOfVisits}`;
  }

  isUserCarePlanServiceAvailable(carePlanServiceUUID: string, filterFieldName: string = 'carePlanServiceUUID') {
    return this.userCarePlanItems.some(userCarePlanItem => userCarePlanItem[filterFieldName] === carePlanServiceUUID && userCarePlanItem.realizationDate === null);

  }

  executeUserCarePlanItem(userCarePlanItem: CountedUserCarePlanItem, $event: any) {
    $event.stopPropagation();
    this.commonUtils.presentYesNoActionSheet('Czy chcesz wykorzystać daną usługę podczas tej wizyty?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {

      this.userCarePlanItemExecutedEventEmitter.emit(userCarePlanItem);

    }, () => {
    });
  }

  checkIfAnyServiceUsed(carePlanServiceUUID: string) {
    const serviceVisits = this.userCarePlanItems.filter(userCarePlanItem => userCarePlanItem.carePlanServiceUUID === carePlanServiceUUID);
    const numberOfVisits = serviceVisits.length;
    const numberOfAvailableVisits = serviceVisits.filter(serviceVisit => serviceVisit.realizationDate === null).length;
    return numberOfVisits !== numberOfAvailableVisits;
  }

  getUsedServices(carePlanServiceUUID: string) {
    const serviceVisits = this.userCarePlanItems.filter(userCarePlanItem => userCarePlanItem.carePlanServiceUUID === carePlanServiceUUID);
    return serviceVisits.filter(serviceVisit => serviceVisit.realizationDate !== null).sort((a, b) => {
      return new Date(a.vetReservationStartDate).getTime() - new Date(b.vetReservationStartDate).getTime();
    });
  }

  checkIfExecuteButtonDisabled(userCarePlanItem: CountedUserCarePlanItem) {

    return this.vetReservationCarePlanItems && this.vetReservationCarePlanItems.some(item => item.carePlanServiceUUID === userCarePlanItem.carePlanServiceUUID);

  }

  isFromVetReservation() {
    return this.vetReservation;
  }

  onRedirectToReservation(used: UserCarePlanItem) {
    this.reservationRedirectEventEmitter.emit(used);
  }

  isRedirectDisabled(used: UserCarePlanItem) {
    return this.vetReservation && this.vetReservation.uuid === used.vetReservationUUID;
  }

  getCarePlanLabelColor(userCarePlanItem: UserCarePlanItem & { count: number }) {
    if (this.vetReservationCarePlanItems && this.vetReservationCarePlanItems.some(item => item.carePlanServiceUUID === userCarePlanItem.carePlanServiceUUID)) {
      return 'success';
    }
    return '';
  }

  checkIfServiceUsed(carePlanServiceUUID: string) {
    return this.vetReservationCarePlanItems && this.vetReservationCarePlanItems.some(item => item.carePlanServiceUUID === carePlanServiceUUID);
  }
}
